import { render } from "./SelecticParameter.vue?vue&type=template&id=1237bbb4&scoped=true"
import script from "./SelecticParameter.vue?vue&type=script&lang=js"
export * from "./SelecticParameter.vue?vue&type=script&lang=js"

import "./SelecticParameter.vue?vue&type=style&index=0&id=1237bbb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1237bbb4"]])

export default __exports__